<template>
  <Modal title="Товары поставщика" @backdrop-click="$emit('close')">
    <template slot="body">
      <CriterionsModal
        v-if="openedModals.searchCriterions"
        :entities-list="providerProducts.entities"
        :default-table-name="currentTable"
        :default-criterion="searchCriterion"
        @on-entity-type-select="setCurrentTable"
        @on-criterion-select="setCriterion"
        @close="openedModals.searchCriterions = false"
      />
      <PriceModal
        v-if="openedModals.price"
        :product="priceModal.product"
        :action-type="priceModal.actionType"
        @on-add="addProductToList"
        @on-edit="editProductFromList"
        @close="openedModals.price = false"
      />
      <Tabs @select-tab="updateTable">
        <Tab v-if="actionType !== 'read'" :title="`Оставшееся (${tabType})`">
          <form @submit.prevent="startSearch">
              <div class="input-group custom-search-form">
                <input
                  maxlength="50"
                  v-model="searchQuery"
                  type="text"
                  class="form-control"
                  placeholder="Искать"
                />
                <span class="input-group-btn">
                  <button
                    v-if="wasSent"
                    class="btn btn-default btn-danger"
                    type="button"
                    @click="resetSearch"
                  >
                    <i class="fa fa-refresh"></i>
                  </button>
                  <button
                    class="btn btn-default btn-primary"
                    type="submit"
                    :disabled="!searchQuery"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </span>
              </div>
            </form>
          <Preloader type="small" v-if="isLoading" />
          <div v-else-if="products.remained.length > 0">
            <div
            class="table-responsive table-responsive_long-list vert-scroll table_provider-products"
          >
            <table class="table">
              <thead>
                <tr>
                  <th
                    v-for="name in ['Название', 'Артикул', 'Штрихкод', 'Тип', 'Действия', 'Ссылка']"
                    :key="name"
                    class="list__column"
                  >
                    {{ name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in products.remained" :key="item.id">
                  <td
                    v-for="row in ['name', 'vendor_code', 'barcode', 'type']"
                    :key="row"
                    class="list__row"
                  >
                    {{ getRow(item[row], 20) }}
                  </td>
                  <td class="list__row">
                    <i
                      class="fa fa-plus-circle icon-size list__icon"
                      @click="openPriceModal(item, 'add')"
                    />
                  </td>
                  <td class="list__row">
                    <router-link :to="`/${currentTable}/${item.id}`" target="_blank">
                      <i class="fa fa-link" />
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab__pagination">
            <Pagination
              :pages-counter="pagesCounter"
              :current-page="currentPage"
              :disabled="isLoading"
              @select="(page) => updateTable('Оставшееся', page)"
            />
          </div>
          </div>
          <p v-else class="modal__products_is-empty">
            Ещё не было добавлено ни одного товара
          </p>
        </Tab>
        <Tab v-if="actionType !== 'read'" title="Добавляемое">
          <Preloader type="small" v-if="isLoading" />
          <div v-else-if="products.adding.length > 0">
            <div
              class="table-responsive table-responsive_long-list vert-scroll table_provider-products"
            >
            <table class="table">
            <thead>
              <tr>
                <th
                  v-for="name in ['Название', 'Цена', 'Сущность', 'Изменение', 'Удаление', 'Ссылка']"
                  :key="name"
                  class="list__column"
                >
                  {{ name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in products.adding" :key="item.id">
                <td
                  v-for="row in ['name', 'price']"
                  :key="row"
                  class="list__row"
                >
                  {{ getRow(item[row], 18) }}
                </td>
                <td class="list__row">
                  {{ getRow(providerProducts.subtypes[item.entityKey], 20) }}
                </td>
                <td class="list__row">
                  <i
                    class="fa fa-edit icon-size list__icon"
                    @click="openPriceModal(item, 'edit')"
                  />
                </td>
                <td class="list__row">
                  <i
                    class="fa fa-trash icon-size list__icon"
                    @click="removeProductFromList(item)"
                  />
                </td>
                <td class="list__row">
                  <router-link :to="`/${providerProducts.tables[item.entityKey]}/${item.id}`" target="_blank">
                    <i class="fa fa-link" />
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
            </div>
          </div>
          <p v-else class="modal__products_is-empty">
            Ещё не было добавлено ни одного товара
          </p>
        </Tab>
        <Tab v-if="actionType !== 'add'" title="Добавленное ранее">
          <Preloader type="small" v-if="isLoading" />
          <div v-else-if="products.alreadyAdded.length > 0">
            <div
              class="table-responsive table-responsive_long-list vert-scroll table_provider-products"
            >
            <table class="table">
            <thead>
              <tr>
                <th
                  v-for="name in ['Название', 'Цена', 'Артикул', 'Штрихкод', 'Тип']"
                  :key="name"
                  class="list__column"
                >
                  {{ name }}
                </th>
                <th v-if="actionType !== 'read'" class="list__column">
                  Изменение
                </th>
                <th v-if="actionType !== 'read'" class="list__column">
                  Удаление
                </th>
                <th class="list__column">
                  Ссылка
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in products.alreadyAdded" :key="item.id">
                <td
                  v-for="row in ['name', 'price', 'vendor_code', 'barcode']"
                  :key="row"
                  class="list__row"
                >
                  {{ getRow(item[row], 18) }}
                </td>
                <td class="list__row">
                  {{ getRow(providerProducts.subtypes[item.entityKey], 20) }}
                </td>
                <td v-if="actionType !== 'read'" class="list__row">
                  <i
                    class="fa fa-edit icon-size list__icon"
                    @click="openPriceModal(item, 'edit')"
                  />
                </td>
                <td v-if="actionType !== 'read'" class="list__row">
                  <i
                    class="fa fa-trash icon-size list__icon"
                    @click="removeProductFromList(item, 'alreadyAdded')"
                  />
                </td>
                <td class="list__row">
                  <router-link :to="`/${providerProducts.tables[item.entityKey]}/${item.id}`" target="_blank">
                    <i class="fa fa-link" />
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
            </div>
          </div>
          <p v-else class="modal__products_is-empty">
            Поставщик ещё не отвечает за какой-либо товар
          </p>
        </Tab>
      </Tabs>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            type="button"
            class="modal-default-button btn btn-danger"
            @click="$emit('close')"
          >
            Отмена
          </button>
        </div>
        <div v-if="confirmButtonIsVisible && actionButtonsAreVisible">
          <button
            class="btn btn-default btn-success"
            type="button"
            :disabled="submitWasDisabled"
            @click="confirmProductsChange"
          >
            <i class="fa fa-check"></i>
            Подтвердить
          </button>
        </div>
        <div v-else-if="!confirmButtonIsVisible && actionButtonsAreVisible">
          <button
            class="btn btn-default btn-warning"
            type="button"
            @click="openedModals.searchCriterions = true"
          >
            <i class="fa fa-gear"></i>
            Параметры
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/_shared/components/ui/Modal';
import Tabs from '@/_shared/components/ui/Tabs';
import Tab from '@/_shared/components/ui/Tab';
import Pagination from '@/_shared/components/ui/Pagination';
import Preloader from '@/_shared/components/ui/Preloader';

import CriterionsModal from '@/_shared/widgets/CriterionsModal';
import PriceModal from '@/business/widgets/provider-products/PriceModal';

import { pagination, objectHelper } from '@/_shared/utils';
import { providerProductsService } from '@/business/api-services';
import { providerProducts } from '@/business/constants';
import {
  useModalSearch,
  usePagination,
  useTableHelper,
  useNotification,
} from '@/_shared/mixins';
export default {
  emits: [
    'on-products-change',
    'close',
  ],
  props: {
    actionType: {
      type: String,
      default: 'read',
    },
    initAddingProducts: {
      type: Array,
      default() {
        return [];
      },
    },
    initRemovingProducts: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  mixins: [
    useModalSearch,
    usePagination,
    useTableHelper,
    useNotification,
  ],
  components: {
    Modal,
    Tabs,
    Tab,
    CriterionsModal,
    PriceModal,
    Pagination,
    Preloader,
  },
  data() {
    return {
      searchQuery: '',
      searchCriterion: 'name',
      wasSent: false,
      notificationGroup: 'modal',
      openedModals: {
        searchCriterions: false,
        price: false,
      },
      products: {
        adding: objectHelper.createCopy(this.initAddingProducts),
        removing: objectHelper.createCopy(this.initRemovingProducts),
        remained: [],
        alreadyAdded: [],
      },
      priceModal: {
        product: null,
        actionType: 'add',
      },
      providerProducts,
      currentTable: 'cloths',
      currentTab: 'Оставшееся (ткани)',
    };
  },
  computed: {
    confirmButtonIsVisible() {
      return !!['Добавляемое', 'Добавленное ранее'].includes(this.currentTab);
    },
    actionButtonsAreVisible() {
      if (this.actionType === 'read') {
        return false;
      }
      return true;
    },
    submitWasDisabled() {
      const hasAlreadySavedValues = (this.initAddingProducts.length > 0
        || this.initRemovingProducts.length > 0);
      if (hasAlreadySavedValues) {
        return false;
      }
      return !!(this.products.adding.length < 1 &&
        this.products.removing.length < 1);
    },
    tabType() {
      return this.providerProducts.entities[this.currentTable].toLowerCase();
    },
  },
  methods: {
    confirmProductsChange() {
      const notificationText = 'Изменения в продуктах будут '
        + 'сохранены при отправке формы поставщика';
      this.notificationGroup = 'main';
      this.showStandardNotification(notificationText);

      const results = objectHelper.createCopy(this.products);
      delete results.remained;
      delete results.alreadyAdded;
      this.$emit('on-products-change', results);
    },
    openPriceModal(product = {}, actionType = 'add') {
      const entities = {};
      Object.entries(providerProducts.sublists).forEach(([key, value]) => {
        entities[value] = key;
      });
      const entity = entities[this.currentTable];
      this.priceModal.product = { ...product, entity };
      this.priceModal.actionType = actionType;
      this.openedModals.price = true;
    },
    editProductFromList(editingProduct = {}) {
      if (this.currentTab === 'Добавленное ранее') {
        this.addProductToList(editingProduct);
        this.removeProductFromList(editingProduct, 'alreadyAdded');
        const text = 'Новая версия товара помещена в раздел "Добавляемое"';
        return this.showStandardNotification(text);
      }
      this.products.adding.forEach((product) => {
        const isEditingItem = product.id === editingProduct.id
          && product.entityKey === editingProduct.entityKey;
        if (isEditingItem) {
          product.price = editingProduct.price;
        }
        return product;
      });
    },
    addProductToList(product = {}) {
      this.products.adding.push(product);
      this.addingProduct = null;
    },
    removeProductFromList(removingProduct, listName = 'adding') {
      const modifiedList = this.products[listName].filter((product) => {
        const isRemovingItem = product.id === removingProduct.id
          && product.entityKey === removingProduct.entityKey
        if (!isRemovingItem) {
          return product;
        }
      });
      this.products[listName] = modifiedList;
      if (listName === 'alreadyAdded') {
        this.products.removing.push(removingProduct);
      }
    },
    async startSearch() {
      this.wasSent = true;
      await this.updateTable();
    },
    async resetSearch() {
      this.searchQuery = '';
      this.wasSent = false;
      await this.updateTable();
    },
    async setCurrentTable(value) {
      this.currentTable = value;
      await this.updateTable();
    },
    async setCriterion(value) {
      this.searchCriterion = value;
      await this.updateTable();
    },
    async updateTable(tabTitle, page = 1) {
      this.currentTab = tabTitle;
      const isAddingProductsTab = !!(tabTitle === 'Добавляемое');
      if (isAddingProductsTab) {
        return
      }
      this.isLoading = true;
      const isAddedProductsTab = !!(tabTitle === 'Добавленное ранее');
      if (isAddedProductsTab) {
        return await this.updateAddedProducts();
      }
      await this.updateRemainedProducts(page);
    },
    async updateAddedProducts() {
      const providerId = this.$route.params.id;
      await providerProductsService.getAdded(providerId, this.products)
        .then((response) => {
          this.products.alreadyAdded = response.records;
          this.isLoading = false;
        });
    },
    async updateRemainedProducts(page) {
      const params = { page };
      if (this.wasSent) {
        params.search = {
          query: this.searchQuery,
          criterion: this.searchCriterion,
        };
      }
      await providerProductsService.getRemained(this.currentTable, params)
        .then((response) => {
          this.products.remained = response.records;
          const pagesCounter = pagination.getPagesCounter(response.results);
          this.usePagination(page, pagesCounter);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal__products_is-empty {
  text-align: center;
  padding: 15vh 0;
}
.table_provider-products {
  margin-top: 1em;
  padding-right: 1em;
}
</style>



// WEBPACK FOOTER //
// src/business/components/ProviderProductsModal.vue